interface ICartComment{
    comment: string,
    classes?: string,
}

const CartComment = (props: ICartComment) => {
    return (
        <div className={ `text-green mb-2 ${ props.classes ? props.classes : ''} `}>
            { props.comment }
        </div>
    )
};

export default CartComment;